import categoryParentApi from "api/CategoryParentApi";
import { FETCH_LIST_CATEGORY_PARENT_SUCCESS } from "redux/ActionTypes/CategoryParentActionTypes";
import { activeProgress, disableProgress } from "./ProgressActionCreators";

export const fetchListCategoryParentRequest = () => {
  return (dispatch) => {
    dispatch(activeProgress());
    return categoryParentApi
      .getAll()
      .then(
        (res) => {
          dispatch(fetchListCategoryParentSuccess(res.body));
        },
        (err) => {}
      )
      .finally(() => {
        dispatch(disableProgress());
      });
  };
};

export const fetchListCategoryParentSuccess = (data) => {
  return {
    type: FETCH_LIST_CATEGORY_PARENT_SUCCESS,
    payload: data,
  };
};
